import { PhoneIcon } from 'lucide-react'
import React from 'react'

import { Button, ButtonGroup, Modal, useBreakpoint } from 'slab'

import { BottomSheetWithHeaderAndFooter } from '../BottomSheetWithHeaderAndFooter'
import { InNetworkPlansCard } from '../InNetworkPlansCard/InNetworkPlansCard'
import { InNetworkProviderCard } from '../InNetworkProviderCard/InNetworkProviderCard'
import { useProviderInNetworkVerificationContext } from '../ProviderInNetworkVerificationContext/ProviderInNetworkVerificationContext'

export const ProviderInNetworkVerificationProgressModal: React.FC<{
  onOpenChange: (open: boolean) => void;
  open: boolean;
}> = ({ open, onOpenChange }) => {
  const { breakpointIsAtLeast } = useBreakpoint()
  const { selectedPlans, verifyingDescription } = useProviderInNetworkVerificationContext()
  const title = (
    <div className='flex items-center gap-2'>
      <PhoneIcon size={18} className='text-gray-500' />
      Provider calls in progress
    </div>
  )

  if (breakpointIsAtLeast('xs')) {
    return (
      <Modal open={open} onOpenChange={onOpenChange} width='large'>
        <div className='bg-gradient-to-t from-gray-50 to-thatch-100 overflow-y-auto'>
          <Modal.Body>
            <Modal.Title>{title}</Modal.Title>
            <Modal.Description>{verifyingDescription}</Modal.Description>
            <InNetworkProviderCard disabled />
            <InNetworkPlansCard plans={selectedPlans} disabled />
          </Modal.Body>
          <Modal.Footer>
            <ButtonGroup>
              <Modal.Button variant='secondary'>
                Close
              </Modal.Button>
            </ButtonGroup>
          </Modal.Footer>
        </div>
      </Modal>
    )
  }
  return (
    <BottomSheetWithHeaderAndFooter
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      footer={
        <ButtonGroup>
          <Button onClick={() => onOpenChange(false)} variant='tertiary-deemphasized'>
            Close
          </Button>
        </ButtonGroup>
      }
    >
      <div className='flex flex-col gap-4'>
        <div className='body-sm text-gray-800 mb-4'>{verifyingDescription}</div>
        <InNetworkProviderCard />
        <InNetworkPlansCard plans={selectedPlans} />
      </div>
    </BottomSheetWithHeaderAndFooter>
  )
}
